module.exports = __webpack_public_path__ + "img/MERS-Black-White.93902ab9.png";